import { mapActions } from 'vuex';
import Events from '_utils/events';
import PuzzleService from '_services/rest/modules/puzzle';

export default {
  name: 'puzzle-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      PuzzleService.deletePuzzle(this.selectPuzzle)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', false);
          this.activeAlert({
            message: this.$t('shared.deletedSuccess'),
            theme: 'success',
          });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
